import React, {useState} from 'react';
import {useNavigate} from 'react-router';
import {Container, MenuItem, Select, Stack, Typography} from '@mui/material';
import {useAlertError, useBusyCallback, useOnce, useQueryParam} from '../../util/react_hooks.js';
import api from '../../util/api.js';
import SCTextField from '../../components/SCTextField.js';
import ConsentCheckbox from '../../components/ConsentCheckbox.js';
import SCButton from '../../components/SCButton.js';
import withMainContainer from '../../components/WithMainContainer.js';
import { useSnackbar } from 'notistack';

const PRICE = 10;

const TarotmailSimonaAddRound = ()=>{
    let [consent, setConsent] = useState(false);
    let [firstName, setFirstName] = useState('');
    let [lastName, setLastName] = useState('');
    let [email, setEmail] = useState('');
    let [phone, setPhone] = useState('');
    let [qsEmail] = useQueryParam('email');
    let [qsFirstName] = useQueryParam('firstName');
    useOnce(()=>setEmail(qsEmail), !!qsEmail);
    useOnce(()=>setFirstName(qsFirstName), !!qsFirstName);
    let navigate = useNavigate();
    let alertError = useAlertError();
    let {enqueueSnackbar} = useSnackbar();
    let [proceed, proceeding] = useBusyCallback(async ()=>{
        try {
            let res = await api.tarotmail.createSimonaAddRoundPaypage(
                {firstName, lastName, email, country: 'IL', phone, consent});
            window.location.href = res.paypage;
        } catch (e) {
            if (e.code=='customer_eligible')
            {
                enqueueSnackbar(e.message, {variant: 'success'});
                return void navigate(`/tarotmail/simona?tmaEmail=${email}`);
            }
            alertError(e);
        }
    }, [navigate, alertError, enqueueSnackbar, firstName, lastName, email, phone, consent]);
    return <Stack direction="column" gap={2} justifyContent="center"
      alignItems="center">
      <Typography variant="h3">
        פתיחת סבב מסרים נוסף
      </Typography>
      <Container maxWidth="md">
        <Stack justifyContent="center" alignItems="center">
          <Stack maxWidth="400px" gap={2} padding={3} sx={{
              border: '1px solid #cccccc',
              borderRadius: '4px',
          }}>
          <SCTextField required label="שם פרטי" value={firstName} onChange={setFirstName}/>
          <SCTextField required label="שם משפחה" value={lastName} onChange={setLastName}/>
          <SCTextField required label={'דוא"ל'} value={email} onChange={setEmail}/>
          <SCTextField required label="טלפון" value={phone} onChange={setPhone}
              placeholder="לדוגמה: 0501234567"/>
          <Stack direction="column" gap={1} sx={{width: '100%'}}>
              <Typography color="text.secondary">מדינה</Typography>
              <Select value="IL">
              <MenuItem value="IL">ישראל</MenuItem>
              </Select>
          </Stack>
          <ConsentCheckbox value={consent} onChange={setConsent}/>
          <SCButton text={`מעבר לתשלום (${PRICE} ש"ח)`} variant="contained"
              onClick={proceed} loading={proceeding}/>
          </Stack>
        </Stack>
      </Container>
    </Stack>;
};

export default withMainContainer(TarotmailSimonaAddRound, {footerMargin: 8});
